// Простые переходы для Motion
export const TRANSITIONS = {
  default: { duration: 0.4, ease: "easeOut" },
  fast: { duration: 0.2, ease: "easeOut" },
  slow: { duration: 0.6, ease: "easeOut" },
  blur: { duration: 0.4, ease: "easeOut" },
  fade: { duration: 0.3, ease: "easeInOut" },
  slide: { duration: 0.5, ease: "easeOut" },
  scale: { duration: 0.3, ease: "easeOut" },
} as const;